<template>
  <div>
    <Modal
      v-model="modal"
      :title="
        !relationalDatabaseServiceWarningForm.id
          ? this.$t('alarms.database.addDatabaseAlarm')
          : this.$t('alarms.database.editDatabaseAlarm')
      "
      @on-cancel="cancel"
      @on-ok="ok"
      :loading="loading"
      :mask-closable="false"
      :styles="{ top: '65px' }"
      width="1000px"
      :footer-hide="true"
      :closable="false"
    >
      <Form
        ref="relationalDatabaseServiceWarningForm"
        :model="relationalDatabaseServiceWarningForm"
        :label-width="110"
        :rules="ruleValidate"
      >
        <!-- 下一步 -->
        <div v-show="isNext">
          <!-- 微信警告 -->
          <wechat-warning
            v-if="wechatWarningVisible"
            ref="wechatWarning"
          ></wechat-warning>
          <!-- 规则名称 -->
          <FormItem
            :label="$t('alarms.common.ruleName')"
            prop="ruleName"
            v-if="isEditRuleName"
          >
            <Row>
              <Col span="11">
                <Input
                  type="text"
                  v-model="relationalDatabaseServiceWarningForm.ruleName"
                  placeholder="Enter something..."
                  style="width: 300px"
                  :disabled="isEdit"
                ></Input>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则名称 -->
          <FormItem :label="$t('alarms.common.ruleName')" v-if="showRuleName">
            <Row>
              <Col span="24">
                <div>
                  {{ this.relationalDatabaseServiceWarningForm.ruleName }}
                </div>
              </Col>
            </Row>
          </FormItem>

          <!-- 规则描述 -->
          <FormItem :label="$t('alarms.common.ruleDescription')">
            <Row :gutter="4">
              <!-- 监控指标 -->
              <Col span="4">
                <FormItem prop="monitorIndex">
                  <Select
                    v-model="relationalDatabaseServiceWarningForm.monitorIndex"
                    @on-change="
                      changeMonitorIndex(
                        relationalDatabaseServiceWarningForm.monitorIndex
                      )
                    "
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="item in monitorIndexList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 周期 -->
              <Col span="3">
                <FormItem prop="cycle">
                  <Select
                    v-model="relationalDatabaseServiceWarningForm.cycle"
                    :placeholder="$t('alarms.common.cycle')"
                    @on-change="
                      changeCycle(relationalDatabaseServiceWarningForm.cycle)
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in cycleList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 连续周期 -->
              <Col span="4">
                <FormItem prop="continousCycle">
                  <Select
                    v-model="
                      relationalDatabaseServiceWarningForm.continousCycle
                    "
                    :placeholder="$t('alarms.common.continuousCycle')"
                    @on-change="
                      changeContinousCycle(
                        relationalDatabaseServiceWarningForm.continousCycle
                      )
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in continousCycleList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <!-- 统计数值 -->
              <Col span="4">
                <FormItem prop="statisticsValue">
                  <Select
                    v-model="
                      relationalDatabaseServiceWarningForm.statisticsValue
                    "
                    :placeholder="$t('alarms.common.statisticsValue')"
                    @on-change="
                      changeStatisticsValue(
                        relationalDatabaseServiceWarningForm.statisticsValue
                      )
                    "
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in statisticsValueList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <!-- 关系符号 -->
              <Col span="3">
                <FormItem prop="relationshipSign">
                  <Select
                    v-model="
                      relationalDatabaseServiceWarningForm.relationshipSign
                    "
                    @on-change="
                      changeRelationshipSign(
                        relationalDatabaseServiceWarningForm.relationshipSign
                      )
                    "
                    :placeholder="$t('alarms.common.symbol')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in relationshipSignList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>

              <!-- 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位 -->
              <div v-if="this.isShowField == 1">
                <!-- 阈值 -->
                <Col span="3" v-if="isNotIOPS">
                  <FormItem prop="thresholdValue">
                    <InputNumber
                      v-model="
                        relationalDatabaseServiceWarningForm.thresholdValue
                      "
                      :placeholder="$t('alarms.common.threshold')"
                      :min="1"
                      :max="14"
                    ></InputNumber>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="2" v-if="isIOPS">
                  <div>{{ $t("alarms.common.standardValue") }}</div>
                </Col>
              </div>
              <div v-else-if="this.isShowField == 2">
                <!-- 阈值 -->
                <Col span="3" v-if="isNotIOPS">
                  <FormItem prop="thresholdValue">
                    <Input
                      v-model="
                        relationalDatabaseServiceWarningForm.thresholdValue
                      "
                      :placeholder="$t('alarms.common.threshold')"
                      type="number"
                    ></Input>
                  </FormItem>
                </Col>
                <!-- 阈值 -->
                <Col span="2" v-if="isIOPS">
                  <div>{{ $t("alarms.common.standardValue") }}</div>
                </Col>
              </div>

              <!-- 单位 -->
              <Col span="2">
                <FormItem prop="unit">
                  <Input
                    v-model="relationalDatabaseServiceWarningForm.unit"
                    disabled
                    :placeholder="$t('alarms.common.unit')"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
          </FormItem>

          <!-- 联系方式 -->
          <FormItem :label="$t('alarms.common.contactType')" prop="contactType">
            <RadioGroup
              v-model="relationalDatabaseServiceWarningForm.contactType"
              @on-change="
                changeContactType(
                  relationalDatabaseServiceWarningForm.contactType
                )
              "
            >
              <Radio
                v-for="item in contactTypeList"
                :label="item.type"
                :key="item.value"
                >{{ item.label }}</Radio
              >
            </RadioGroup>
          </FormItem>

          <!-- 通知对象 -->
          <FormItem
            :label="$t('alarms.common.notificationObject')"
            prop="notificationObject"
            v-if="relationalDatabaseServiceWarningForm.contactType == 0"
          >
            <Select
              v-model="relationalDatabaseServiceWarningForm.notificationObject"
              multiple
              style="width: 300px"
              @on-change="changeNotificationObject"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in notificationObjectList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 联系人组 -->
          <FormItem
            :label="$t('alarms.common.contactGroup')"
            prop="contactGroupIds"
            v-if="relationalDatabaseServiceWarningForm.contactType == 1"
          >
            <Select
              v-model="relationalDatabaseServiceWarningForm.contactGroupIds"
              multiple
              style="width: 300px"
              @on-change="
                changeContactGroupId(
                  relationalDatabaseServiceWarningForm.contactGroupIds
                )
              "
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in contactGroupIdList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 报警方式 -->
          <FormItem :label="$t('alarms.common.noticeType')" prop="noticeType">
            <Select
              v-model="relationalDatabaseServiceWarningForm.noticeType"
              multiple
              style="width: 300px"
              @on-change="
                selectnoticeType(
                  relationalDatabaseServiceWarningForm.noticeType
                )
              "
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmWayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 企业微信机器人URL -->
          <FormItem
            :label="$t('alarms.common.enterpriseWeChatRobotURL')"
            prop="enterpriseWechatRobotIds"
            v-if="
              relationalDatabaseServiceWarningForm.noticeType.filter(function (
                e
              ) {
                return e == 3;
              }).length != 0
            "
          >
            <Select
              v-model="
                relationalDatabaseServiceWarningForm.enterpriseWechatRobotIds
              "
              multiple
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in enterpriseWechatRobotIdsList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 延迟告警 -->
          <FormItem :label="$t('alarms.common.alarmDelay')" prop="alarmDelay">
            <Select
              v-model="relationalDatabaseServiceWarningForm.alarmDelay"
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in alarmDelayList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- 监控时段 -->
          <FormItem
            :label="$t('alarms.common.monitorPeriod')"
            prop="monitorPeriod"
          >
            <Select
              v-model="relationalDatabaseServiceWarningForm.monitorPeriod"
              style="width: 300px"
              :placeholder="$t('alarms.common.pleaseSelect')"
            >
              <Option
                v-for="item in monitorPeriodList"
                :value="item.id"
                :key="item.id"
                >{{ item.name }}</Option
              >
            </Select>
          </FormItem>

          <!-- AI是否接管 -->
          <FormItem :label="$t('alarms.common.aiIntervention')">
            <i-switch
              size="large"
              :true-value="1"
              :false-value="0"
              v-model="relationalDatabaseServiceWarningForm.aiInterventionEnabled"
            >
              <span slot="open">{{ $t('alarms.common.aiInterventionYes') }}</span>
              <span slot="close">{{ $t('alarms.common.aiInterventionNo') }}</span>
            </i-switch>
          </FormItem>

          <!-- 邮箱模板 -->
          <div v-show="isShowEmail">
            <FormItem :label="$t('alarms.common.emailModal')" prop="emailModal">
              <Input
                v-model="relationalDatabaseServiceWarningForm.emailModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>

          <!-- 企业微信模板 -->
          <div v-show="isShowWeChat">
            <FormItem
              :label="$t('alarms.common.wechatModal')"
              prop="wechatModal"
            >
              <Input
                v-model="relationalDatabaseServiceWarningForm.wechatModal"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 5 }"
                style="width: 665px"
                disabled
              ></Input>
            </FormItem>
          </div>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              style="float: right"
              @click="ok('relationalDatabaseServiceWarningForm')"
              :loading="addloading"
              :disabled="isAddOrEdit"
              >{{
                !relationalDatabaseServiceWarningForm.id
                  ? this.$t("common.addAlarm")
                  : this.$t("common.editAlarm")
              }}</Button
            >
            <Button
              size="large"
              style="float: right; margin-right: 10px"
              @click="cancel('relationalDatabaseServiceWarningForm')"
              >{{ $t("alarms.common.cancel") }}</Button
            >
            <Button
              size="large"
              @click="previousPage"
              style="float: right; margin-right: 10px"
              >{{ $t("alarms.common.lastStep") }}</Button
            >
          </div>
        </div>

        <!-- 上一步 -->
        <div v-show="isPrevious">
          <div>
            <Row :gutter="16">
              <Col span="4">
                <!-- 云平台 -->
                <FormItem
                  :label="$t('alarms.common.cloudPlatform')"
                  prop="accountTypeSearchKey"
                  :label-width="60"
                >
                  <Select
                    v-model="
                      relationalDatabaseServiceWarningForm.accountTypeSearchKey
                    "
                    filterable
                    @on-change="
                      searchAccountType(
                        relationalDatabaseServiceWarningForm.accountTypeSearchKey
                      )
                    "
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="item in accountTypeList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="6">
                <!-- 账户 -->
                <FormItem
                  :label="$t('alarms.common.account')"
                  prop="account"
                  :label-width="70"
                >
                  <Select
                    v-model="relationalDatabaseServiceWarningForm.account"
                    @on-change="
                      changeAccount(
                        relationalDatabaseServiceWarningForm.account
                      )
                    "
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.id"
                      v-for="(item, index) in accountList"
                      v-bind:key="index"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="6">
                <!-- 存储区域 -->
                <FormItem
                  :label="$t('alarms.common.region')"
                  prop="backupRegion"
                >
                  <Select
                    @on-change="
                      changebackupRegion(
                        relationalDatabaseServiceWarningForm.backupRegion
                      )
                    "
                    v-model="relationalDatabaseServiceWarningForm.backupRegion"
                    multiple
                    :max-tag-count="1"
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Checkbox
                      v-model="singleBackupRegion"
                      @on-change="selectBackupRegionAll"
                      style="display: block; text-align: right"
                      >{{ $t("alarms.common.all") }}</Checkbox
                    >
                    <Option
                      :value="item.name"
                      v-for="item in backupRegionList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="6" v-show="isDatabaseEngines">
                <!-- 数据库引擎 -->
                <FormItem
                  :label="$t('alarms.database.engine')"
                  prop="databaseEngines"
                >
                  <Select
                    v-model="
                      relationalDatabaseServiceWarningForm.databaseEngines
                    "
                    @on-change="
                      changeDatabaseEngines(
                        relationalDatabaseServiceWarningForm.databaseEngines
                      )
                    "
                    :transfer="true"
                    :placeholder="$t('alarms.common.pleaseSelect')"
                  >
                    <Option
                      :value="item.name"
                      v-for="item in databaseEnginesList"
                      :key="item.id"
                      >{{ item.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Button
                type="primary"
                style="float: right"
                @click="searchRDSDate"
                v-show="isShowSearch"
                >{{ $t("alarms.common.search") }}</Button
              >
            </Row>
          </div>

          <v-table
            :height="459"
            column-width-drag
            is-horizontal-resize
            style="width: 100%; height: 459px; margin-bottom: 15px"
            :columns="column"
            :table-data="tableRDSDate"
            row-hover-color="#edf7ff"
            :is-loading="modal_loadings"
            title-bg-color="#f8f8f9"
            :select-group-change="selectChange"
            :select-all="selectAll"
          ></v-table>
          <div style="height: 42px">
            <Button
              type="primary"
              size="large"
              @click="nextPage"
              style="float: right"
              :disabled="isNextClick"
              >{{ $t("alarms.common.nextStep") }}</Button
            >
            <Button
              size="large"
              style="margin-right: 10px; float: right"
              @click="cancel('relationalDatabaseServiceWarningForm')"
              >{{ $t("alarms.common.cancel") }}</Button
            >
          </div>
        </div>
      </Form>
    </Modal>
  </div>
</template>
<script>
import WechatWarning from "../common/WechatWarning.vue";
import { setCookie, getCookie } from "../../../utils/cookieUtil.js";
import TableRelationalDatabaseService from "../rds/TableRelationalDatabaseService.vue";
var tableRelationalDatabaseService = TableRelationalDatabaseService;
var tableRDSWarningVue = {};
export default {
  inject: ["reload"],
  components: {
    WechatWarning,
  },
  data() {
    // 名字是否重复
    var validNameRepeatedCheck = (rule, value, callback) => {
      var self = this;
      var validNameRepeatedCheckList = {
        alertRuleName: this.relationalDatabaseServiceWarningForm.ruleName,
      };
      // 如果不是Azure monitor传1
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 0 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 1 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
      ) {
        validNameRepeatedCheckList.monitorModule = 1;
      }
      // 如果是Azure 且数据库引擎为MySQL  monitor传18
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines == "MySQL"
      ) {
        validNameRepeatedCheckList.monitorModule = 18;
      }
      // 如果是Azure 且数据库引擎为SQL Server  monitor传19
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines ==
          "SQL Server"
      ) {
        validNameRepeatedCheckList.monitorModule = 19;
      }

      self.$api.alertRule
        .nameRepeatedCheck(validNameRepeatedCheckList)
        .then((res) => {
          if (res.status == 200) {
            callback();
          }
        })
        .catch((err) => {
          if (err.status == 400) {
            callback(new Error(this.$t("monitor.rds.warning.rule.ruleNameDuplicate")));
          }
        });
    };
    return {
      isAddOrEdit: true,
      wechatWarningVisible: false,
      contactTypeList: [
        {
          label: this.$t("alarms.common.contactPerson"),
          value: "contact",
          type: 0,
        },
        {
          label: this.$t("alarms.common.contactGroup"),
          value: "contactGroup",
          type: 1,
        },
      ],
      addloading: false,
      singleBackupRegion: false,
      alarmDelayList: [],
      monitorPeriodList: [],
      accountTypeList: [],
      databaseEnginesList: [],
      isNotIOPS: true,
      isIOPS: false,
      isDatabaseEngines: false,
      isEdit: false,
      isShowSearch: false,
      isEditRuleName: false,
      showRuleName: false,
      isShowField: "2", //是否显示符号、阈值和单位
      isShowEmail: false,
      isShowWeChat: false,
      isNext: false,
      isPrevious: true,
      selection: [],
      accountList: [],
      alarmWayList: [],
      notificationObjectList: [],
      backupRegionList: [],
      loading: true,
      modal: false,
      modal_loading: false,
      modal_loadings: false,
      exportDataList: "",
      noticeType: [],
      units: "",
      isNextClick: true, //禁止点击下一步
      unit: "",
      state: [
        "creating",
        "available",
        "stopping",
        "stopped",
        "shutting down",
        "terminated",
        "running",
      ],
      relationalDatabaseServiceWarningForm: {
        account: "",
        ruleName: "",
        notificationObject: [],
        noticeType: [],
        emailModal: "",
        wechatModal: "",
        thresholdValue: "",
        monitorIndex: "",
        cycle: "",
        continousCycle: "",
        statisticsValue: "",
        relationshipSign: "",
        unit: "",
        backupRegion: [],
        databaseEngines: "",
        accountTypeSearchKey: "",
        alarmDelay: "",
        monitorPeriod: "",
        contactType: 0,
        contactGroupIds: [],
        userIdList: [],
        enterpriseWechatRobotIds: [],
        aiInterventionEnabled: 1,
      },
      enterpriseWechatRobotIdsList: [],
      // 联系人组
      contactGroupIdList: [],
      // 监控指标
      monitorIndexList: [],
      // 周期
      cycleList: [],
      // 连续周期
      continousCycleList: [],
      // 统计数值
      statisticsValueList: [],
      // 关系符号
      relationshipSignList: [],
      ruleValidate: {
        account: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectAccount"),
            trigger: "change",
            type: "number",
          },
        ],
        alarmDelay: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectAlarmDelay"),
            trigger: "change",
            type: "number",
          },
        ],
        monitorPeriod: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectMonitorPeriod"),
            trigger: "change",
            type: "number",
          },
        ],
        accountTypeSearchKey: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectCloudPlatform"),
            trigger: "change",
            type: "number",
          },
        ],
        backupRegion: [
          {
            required: true,
            type: "array",
            message: this.$t("monitor.rds.warning.rule.selectRegion"),
            trigger: "change",
          },
        ],
        databaseEngines: [
          { required: false, message: this.$t("monitor.rds.warning.rule.selectDatabaseEngine"), trigger: "change" },
        ],
        ruleName: [
          { required: true, message: this.$t("monitor.rds.warning.rule.ruleNameRequired"), trigger: "blur" },
          {
            type: "string",
            message: this.$t("monitor.rds.warning.rule.ruleNamePattern"),
            pattern: "^[^ ]{2,20}$",
            trigger: "blur",
          },
          { validator: validNameRepeatedCheck, trigger: "blur" },
        ],
        notificationObject: [
          {
            required: true,
            type: "array",
            message: this.$t("monitor.rds.warning.rule.selectNotificationObject"),
            trigger: "change",
          },
        ],
        noticeType: [
          {
            required: true,
            type: "array",
            min: 1,
            message: this.$t("monitor.rds.warning.rule.selectNoticeType"),
            trigger: "change",
          },
        ],
        monitorIndex: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectMonitorIndex"),
            trigger: "change",
            type: "number",
          },
        ],
        cycle: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectCycle"),
            trigger: "change",
            type: "number",
          },
        ],
        continousCycle: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectContinousCycle"),
            trigger: "change",
            type: "number",
          },
        ],
        statisticsValue: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectStatisticsValue"),
            trigger: "change",
            type: "number",
          },
        ],
        relationshipSign: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectRelationshipSign"),
            trigger: "change",
            type: "number",
          },
        ],
        thresholdValue: [{ required: true, message: this.$t("monitor.rds.warning.rule.thresholdRequired") }],
        contactType: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectContactType"),
            trigger: "change",
            type: "number",
          },
        ],
        contactGroupIds: [
          {
            required: true,
            message: this.$t("monitor.rds.warning.rule.selectContactGroup"),
            trigger: "change",
            type: "array",
          },
        ],
        enterpriseWechatRobotIds: [
          {
            required: true,
            type: "array",
            message: this.$t("monitor.rds.warning.rule.selectEnterpriseWechatRobot"),
            trigger: "change",
          },
        ],
      },
      column: [
        {
          width: 60,
          titleAlign: "center",
          columnAlign: "center",
          type: "selection",
        },
        {
          title: this.$t("alarms.database.databaseId"),
          field: "databaseId",
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          width: 80,
        },
        {
          title: this.$t("alarms.database.engine"),
          field: "engine",
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          width: 80,
        },
        {
          title: this.$t("alarms.database.instanceType"),
          field: "type",
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          width: 80,
        },
        {
          title: this.$t("alarms.database.state"),
          field: "stateName",
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          width: 80,
        },
        {
          title: this.$t("alarms.database.region"),
          field: "region",
          titleAlign: "center",
          columnAlign: "center",
          isResize: true,
          width: 80,
        },
      ],
      tableRDSDate: [],
      newTableRDSDateList: [],
      databaseList: [],
      compareDatabaseList: [],
    };
  },

  beforeCreate: function () {
    tableRDSWarningVue = this;
  },
  methods: {
    // 下一步
    nextPage: function () {
      this.isNext = true;
      this.isPrevious = false;
      // 查询监控指标
      tableRDSWarningVue.searchMonitorIndex();
      // 查询阈值
      tableRDSWarningVue.selectMonitorIndexDefault();
      // 监控模块查询关联的机器人列表
      tableRDSWarningVue.listEnterpriseWechatRobotsByMonitorModule();
      // 查询联系人组
      tableRDSWarningVue.listContactGroups();
    },
    // 上一步
    previousPage: function () {
      this.isNext = false;
      this.isPrevious = true;
    },
    init: function (id) {
      this.relationalDatabaseServiceWarningForm.id = id || 0;
      // 根据用户名查询Account列表
      tableRDSWarningVue.getAccount();
      this.$nextTick(() => {
        // 重置表单
        this.$refs["relationalDatabaseServiceWarningForm"].resetFields();
        // 编辑
        if (this.relationalDatabaseServiceWarningForm.id) {
          // 编辑显示不能输入的规则名称
          this.showRuleName = true;
          this.isEdit = true;
          this.isShowSearch = false;
          // 根据ID查询报警规则
          /****************************************************************/
          this.$api.alertRule
            .selectAlertRule("id", this.relationalDatabaseServiceWarningForm.id)
            .then((res) => {
              //延时
              this.relationalDatabaseServiceWarningForm.alarmDelay =
                res.data.delay;
              //监控时段
              this.relationalDatabaseServiceWarningForm.monitorPeriod =
                res.data.monitorPeriod;
              // AI是否接管
              this.relationalDatabaseServiceWarningForm.aiInterventionEnabled =
                res.data.aiInterventionEnabled === 0 ? 0 : 1;
              // 云平台
              /******************************************************/
              this.relationalDatabaseServiceWarningForm.accountTypeSearchKey =
                res.data.accountType;
              if (
                this.relationalDatabaseServiceWarningForm
                  .accountTypeSearchKey == 2
              ) {
                this.isDatabaseEngines = true;
              } else if (
                this.relationalDatabaseServiceWarningForm
                  .accountTypeSearchKey == 6
              ) {
                this.isDatabaseEngines = true;
                this.databaseEnginesList = [
                  { id: 1, name: "MySQL" },
                  { id: 2, name: "PostgreSQL" }
                ];
              } else {
                this.isDatabaseEngines = false;
              }
              // 数据库引擎（回显到下拉框，延迟确保下拉列表已渲染）
              /******************************************************/
              setTimeout(() => {
                this.relationalDatabaseServiceWarningForm.databaseEngines =
                  this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
                    ? res.data.databaseEngines
                    : res.data.azureEngine;
              }, 1500);

              // 账户
              /******************************************************/
              this.$api.account
                .selectAccountByCloudPlatform(
                  "type",
                  this.relationalDatabaseServiceWarningForm.accountTypeSearchKey
                )
                .then((res) => {
                  this.accountList = res.data;
                });
              this.relationalDatabaseServiceWarningForm.account =
                res.data.accountId;

              // 存储区域
              tableRDSWarningVue.$api.account
                .queryAccountRegions(
                  "accountId",
                  this.relationalDatabaseServiceWarningForm.account
                )
                .then((res) => {
                  this.backupRegionList = res.data;
                });
              //查询联系人
              tableRDSWarningVue.queryContacts();

              this.modal_loadings = true;
              setTimeout(() => {
                // 存储区域
                this.relationalDatabaseServiceWarningForm.backupRegion =
                  res.data.regions;

                // 数据库引擎（在queryDatabaseByGroup之前设置，确保engineType有值）
                this.relationalDatabaseServiceWarningForm.databaseEngines =
                  this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
                    ? res.data.databaseEngines
                    : res.data.azureEngine;

                // 数据库列表
                /******************************************************/
                this.databaseList = res.data.databaseList;
                this.compareDatabaseList = res.data.databaseList;

                // 根据AccountId查询RDS列表
                tableRDSWarningVue.$api.groupDatabaseRelation
                  .queryDatabaseByGroup({
                    regions:
                      this.relationalDatabaseServiceWarningForm.backupRegion,
                    accountId:
                      this.relationalDatabaseServiceWarningForm.account,
                    engineType:
                      this.relationalDatabaseServiceWarningForm.databaseEngines,
                  })
                  .then((res) => {
                    this.tableRDSDate = res.data;
                    this.modal_loadings = false;
                    for (var i = 0; i < this.tableRDSDate.length; i++) {
                      for (
                        var j = 0;
                        j < this.compareDatabaseList.length;
                        j++
                      ) {
                        if (
                          this.tableRDSDate[i].databaseId ==
                          this.compareDatabaseList[j].databaseId
                        ) {
                          this.tableRDSDate[i]._checked = true;
                        }
                      }
                    }
                    // 选了数据 可以点击下一步
                    if (
                      this.tableRDSDate.length == 0 ||
                      this.compareDatabaseList.length == 0
                    ) {
                      this.isNextClick = true;
                    } else {
                      this.isNextClick = false;
                    }
                  });
              }, 1000);

              this.newTableRDSDateList = res.data.databaseList;

              // 规则名称
              this.relationalDatabaseServiceWarningForm.ruleName =
                res.data.alertRuleName;

              // 监控指标
              /******************************************************/
              this.relationalDatabaseServiceWarningForm.monitorIndex =
                res.data.monitorIndex;
              // 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位
              if (
                this.relationalDatabaseServiceWarningForm.monitorIndex == 27
              ) {
                this.isShowField = 1;
              } else {
                this.isShowField = 2;
              }

              // 如果监控指标为读写吞吐量时 不显示阈值
              if (
                this.relationalDatabaseServiceWarningForm.monitorIndex == 28 ||
                this.relationalDatabaseServiceWarningForm.monitorIndex == 29
              ) {
                this.isIOPS = true;
                this.isNotIOPS = false;
              } else {
                this.isNotIOPS = true;
                this.isIOPS = false;
              }

              // 周期
              this.relationalDatabaseServiceWarningForm.cycle = res.data.cycle;
              // 连续周期
              this.relationalDatabaseServiceWarningForm.continousCycle =
                res.data.continousCycle;
              // 统计数值
              this.relationalDatabaseServiceWarningForm.statisticsValue =
                res.data.statisticsValue;
              // 符号
              this.relationalDatabaseServiceWarningForm.relationshipSign =
                res.data.relationshipSign;
              // 阈值
              this.relationalDatabaseServiceWarningForm.thresholdValue =
                res.data.thresholdValue;
              // 单位
              this.relationalDatabaseServiceWarningForm.unit = res.data.unit;
              this.units = res.data.unitId;

              // 企业微信机器人URL
              this.relationalDatabaseServiceWarningForm.enterpriseWechatRobotIds =
                res.data.enterpriseWechatRobotIds;

              // 联系方式
              this.relationalDatabaseServiceWarningForm.contactType =
                res.data.contactType;
              if (res.data.contactType == 0) {
                // 通知对象
                this.relationalDatabaseServiceWarningForm.notificationObject =
                  res.data.contactIDs;
                for (
                  var i = 0;
                  i <
                  this.relationalDatabaseServiceWarningForm.notificationObject
                    .length;
                  i++
                ) {
                  for (var j = 0; j < this.notificationObjectList.length; j++) {
                    if (
                      this.relationalDatabaseServiceWarningForm
                        .notificationObject[i] ==
                      this.notificationObjectList[j].id
                    ) {
                      this.relationalDatabaseServiceWarningForm.userIdList.push(
                        this.notificationObjectList[j].userId
                      ); //传值
                    }
                  }
                }
              } else if (res.data.contactType == 1) {
                // 联系人组
                this.$api.contactGroup
                  .listContactGroupsByAccountId(
                    "accountId",
                    this.relationalDatabaseServiceWarningForm.account
                  )
                  .then((res) => {
                    this.contactGroupIdList = res.data;
                  });
                setTimeout(() => {
                  this.relationalDatabaseServiceWarningForm.contactGroupIds =
                    res.data.contactGroupIds;
                }, 1000);
              }

              // 报警方式
              this.relationalDatabaseServiceWarningForm.noticeType =
                res.data.noticeType;
              for (
                var i = 0;
                i < this.relationalDatabaseServiceWarningForm.noticeType.length;
                i++
              ) {
                if (
                  this.relationalDatabaseServiceWarningForm.noticeType[i] == "0"
                ) {
                  this.isShowEmail = true;
                  this.relationalDatabaseServiceWarningForm.emailModal =
                    res.data.briefReportBodyMail;
                  this.noticeType =
                    this.relationalDatabaseServiceWarningForm.noticeType;
                  tableRDSWarningVue.selectTemplate();
                }
                if (
                  this.relationalDatabaseServiceWarningForm.noticeType[i] == "1"
                ) {
                  // this.isShowWeChat = true;
                  this.relationalDatabaseServiceWarningForm.wechatModal =
                    res.data.briefReportBodyWechat;
                  this.checkLeastOnePersonBoundWeChat();
                  this.noticeType =
                    this.relationalDatabaseServiceWarningForm.noticeType;
                  tableRDSWarningVue.selectTemplate();
                } else if (
                  this.relationalDatabaseServiceWarningForm.noticeType[i] != "1"
                ) {
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = false;
                }
              }
            });
        } else {
          this.tableRDSDate = [];
          this.isEdit = false;
          // 添加显示规则名称能输入
          this.isEditRuleName = true;
          this.showRuleName = false;
        }
      });
      this.modal = true;
      this.isNext = false;
      this.isPrevious = true;
    },

    // 根据监控指标 显示不同单位
    /****************************************************************/
    // 清空周期、连续周期、统计数值、关系符号
    emptyDate: function () {
      this.relationalDatabaseServiceWarningForm.cycle = "";
      this.relationalDatabaseServiceWarningForm.continousCycle = "";
      this.relationalDatabaseServiceWarningForm.statisticsValue = "";
      this.relationalDatabaseServiceWarningForm.relationshipSign = "";
      if (this.isShowField == 1) {
        this.relationalDatabaseServiceWarningForm.thresholdValue = 14;
      } else {
        this.relationalDatabaseServiceWarningForm.thresholdValue = "";
      }
    },
    isNotEmpty: function (obj) {
      if (typeof obj === "undefined" || obj === null || obj === "") {
        return false;
      } else {
        return true;
      }
    },
    // 根据监控指标 显示不同单位
    changeMonitorIndex: function () {
      // 如果监控指标为实例健康状态或者系统健康状态或者实例维护信息时 不显示符号、阈值和单位
      if (this.relationalDatabaseServiceWarningForm.monitorIndex == 27) {
        this.isShowField = 1;
      } else {
        this.isShowField = 2;
      }

      // 如果监控指标为读写吞吐量时 不显示阈值
      if (
        this.relationalDatabaseServiceWarningForm.monitorIndex == 28 ||
        this.relationalDatabaseServiceWarningForm.monitorIndex == 29
      ) {
        this.isIOPS = true;
        this.isNotIOPS = false;
      } else {
        this.isNotIOPS = true;
        this.isIOPS = false;
      }

      tableRDSWarningVue.selectMonitorIndexDefault();
      this.unit = this.relationalDatabaseServiceWarningForm.monitorIndex;
      for (var i = 0; i < this.monitorIndexList.length; i++) {
        if (this.monitorIndexList[i].id == this.unit) {
          this.relationalDatabaseServiceWarningForm.unit =
            this.monitorIndexList[i].unit;
          this.units = this.monitorIndexList[i].id;
        }
      }
      tableRDSWarningVue.selectTemplate();
      tableRDSWarningVue.emptyDate();
    },
    // 查询阈值
    /****************************************************************/
    selectMonitorIndexDefault: function () {
      if (
        this.relationalDatabaseServiceWarningForm.account == "" ||
        this.relationalDatabaseServiceWarningForm.account == null
      ) {
        return;
      }
      var selectMonitorIndexDefaultList = {
        monitorIndex: this.relationalDatabaseServiceWarningForm.monitorIndex,
        cycle: this.relationalDatabaseServiceWarningForm.cycle,
        continousCycle:
          this.relationalDatabaseServiceWarningForm.continousCycle,
        statisticsValue:
          this.relationalDatabaseServiceWarningForm.statisticsValue,
        relationshipSign:
          this.relationalDatabaseServiceWarningForm.relationshipSign,
        accountId: this.relationalDatabaseServiceWarningForm.account,
      };
      // 如果不是Azure monitor传1
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 0 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 1 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
      ) {
        selectMonitorIndexDefaultList.monitorModule = 1;
      }
      // 如果是Azure 且数据库引擎为MySQL  monitor传18
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines == "MySQL"
      ) {
        selectMonitorIndexDefaultList.monitorModule = 18;
      }
      // 如果是Azure 且数据库引擎为SQL Server  monitor传19
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines ==
          "SQL Server"
      ) {
        selectMonitorIndexDefaultList.monitorModule = 19;
      }

      tableRDSWarningVue.$api.alertRule
        .selectMonitorIndexDefault(selectMonitorIndexDefaultList)
        .then((res) => {
          // 周期
          this.cycleList = res.data.cycleMap;
          // 连续周期
          this.continousCycleList = res.data.continousCycleMap;
          // 统计数值
          this.statisticsValueList = res.data.statisticsValueMap;
          // 关系符号
          this.relationshipSignList = res.data.relationshipSignMap;
          // // 阈值
          if (
            res.data.companyMonitoritemVariablesList.length == 1 &&
            tableRDSWarningVue.isNotEmpty(
              this.relationalDatabaseServiceWarningForm.cycle
            ) &&
            tableRDSWarningVue.isNotEmpty(
              this.relationalDatabaseServiceWarningForm.continousCycle
            ) &&
            tableRDSWarningVue.isNotEmpty(
              this.relationalDatabaseServiceWarningForm.statisticsValue
            ) &&
            tableRDSWarningVue.isNotEmpty(
              this.relationalDatabaseServiceWarningForm.relationshipSign
            ) &&
            this.relationalDatabaseServiceWarningForm.id == 0
          ) {
            this.relationalDatabaseServiceWarningForm.thresholdValue =
              res.data.companyMonitoritemVariablesList[0].customerMonitorIndexDefaultValue;
          }
        });
    },
    // 查询邮件模板
    /****************************************************************/
    selectTemplate: function () {
      var selectTemplateList = {
        monitorIndex: this.relationalDatabaseServiceWarningForm.monitorIndex,
        relationshipSign:
          this.relationalDatabaseServiceWarningForm.relationshipSign,
        noticeType: this.relationalDatabaseServiceWarningForm.noticeType,
      };
      // 如果不是Azure monitor传1
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 0 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 1 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 4 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
      ) {
        selectTemplateList.monitorModule = 1;
      }
      // 如果是Azure 且数据库引擎为MySQL  monitor传18
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines == "MySQL"
      ) {
        selectTemplateList.monitorModule = 18;
      }
      // 如果是Azure 且数据库引擎为SQL Server  monitor传19
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines ==
          "SQL Server"
      ) {
        selectTemplateList.monitorModule = 19;
      }

      tableRDSWarningVue.$api.briefReport
        .selectTemplate(selectTemplateList)
        .then((res) => {
          this.relationalDatabaseServiceWarningForm.wechatModal =
            res.data.briefReportBodyWechat;
          this.relationalDatabaseServiceWarningForm.emailModal =
            res.data.briefReportBodyMail;
        });
    },
    //报警方式为邮箱显示邮箱模板  为企业微信显示企业微信模板
    selectnoticeType: function () {
      this.isShowEmail = false;
      this.isShowWeChat = false;
      for (
        var i = 0;
        i < this.relationalDatabaseServiceWarningForm.noticeType.length;
        i++
      ) {
        if (this.relationalDatabaseServiceWarningForm.noticeType[i] == "0") {
          this.isShowEmail = true;
          this.noticeType =
            this.relationalDatabaseServiceWarningForm.noticeType;
          tableRDSWarningVue.selectTemplate();
        }
        if (this.relationalDatabaseServiceWarningForm.noticeType[i] == "1") {
          // this.isShowWeChat = true;
          this.noticeType =
            this.relationalDatabaseServiceWarningForm.noticeType;
          this.checkLeastOnePersonBoundWeChat();
          tableRDSWarningVue.selectTemplate();
        } else if (
          this.relationalDatabaseServiceWarningForm.noticeType[i] != "1"
        ) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 检查至少有一人绑定过微信
    checkLeastOnePersonBoundWeChat: function () {
      for (
        var i = 0;
        i < this.relationalDatabaseServiceWarningForm.noticeType.length;
        i++
      ) {
        if (this.relationalDatabaseServiceWarningForm.noticeType[i] == 1) {
          var weChatDate = {
            contactType: this.relationalDatabaseServiceWarningForm.contactType,
          };
          // 联系方式为 -联系人-
          if (this.relationalDatabaseServiceWarningForm.contactType == 0) {
            weChatDate.userIds =
              this.relationalDatabaseServiceWarningForm.userIdList;
          }
          // 联系方式为 -联系人组-
          else if (this.relationalDatabaseServiceWarningForm.contactType == 1) {
            weChatDate.contactGroupIds =
              this.relationalDatabaseServiceWarningForm.contactGroupIds;
          }
          this.$api.userWeChat
            .checkLeastOnePersonBoundWeChat(weChatDate)
            .then((res) => {
              if (res.data) {
                // 可以添加告警
                this.wechatWarningVisible = false;
                this.isAddOrEdit = false;
              } else {
                // 不可以添加微信告警
                this.wechatWarningVisible = true;
                this.isAddOrEdit = true;
              }
            });
        } else if (
          this.relationalDatabaseServiceWarningForm.noticeType[i] != 1
        ) {
          this.wechatWarningVisible = false;
          this.isAddOrEdit = false;
        }
      }
    },
    // 联系人组
    listContactGroups: function () {
      this.$api.contactGroup
        .listContactGroupsByAccountId(
          "accountId",
          this.relationalDatabaseServiceWarningForm.account
        )
        .then((res) => {
          this.contactGroupIdList = res.data;
        });
    },
    // 切换联系人组
    changeContactGroupId: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换通知对象
    changeNotificationObject: function (val) {
      this.relationalDatabaseServiceWarningForm.userIdList = [];
      this.relationalDatabaseServiceWarningForm.notificationObject = val;
      for (
        var i = 0;
        i < this.relationalDatabaseServiceWarningForm.notificationObject.length;
        i++
      ) {
        for (var j = 0; j < this.notificationObjectList.length; j++) {
          if (
            this.relationalDatabaseServiceWarningForm.notificationObject[i] ==
            this.notificationObjectList[j].id
          ) {
            this.relationalDatabaseServiceWarningForm.userIdList.push(
              this.notificationObjectList[j].userId
            ); //传值
          }
        }
      }
      this.checkLeastOnePersonBoundWeChat();
    },
    // 切换联系方式
    changeContactType: function () {
      this.checkLeastOnePersonBoundWeChat();
    },
    //点击查询 加载全部数据
    /***********************************************************************************/
    searchRDSDate: function () {
      if (
        this.relationalDatabaseServiceWarningForm.account == "" ||
        this.relationalDatabaseServiceWarningForm.account == null ||
        this.relationalDatabaseServiceWarningForm.backupRegion == "" ||
        this.relationalDatabaseServiceWarningForm.backupRegion == null
      ) {
        return;
      }
      this.modal_loadings = true;
      // 根据AccountId查询RDS列表
      tableRDSWarningVue.$api.groupDatabaseRelation
        .queryDatabaseByGroup({
          regions: this.relationalDatabaseServiceWarningForm.backupRegion,
          accountId: this.relationalDatabaseServiceWarningForm.account,
          engineType: this.relationalDatabaseServiceWarningForm.databaseEngines,
        })
        .then((res) => {
          this.tableRDSDate = res.data;
          this.modal_loadings = false;
        });
    },

    /**************************************  查询  **************************************/
    //查询云平台
    getAccountType: function () {
      this.$api.account
        .queryCloudPlatforms("userName", getCookie(global.cookieName))
        .then((res) => {
          this.accountTypeList = res.data;
        });
    },
    // 查询数据库引擎
    queryDatabaseEngines: function () {
      tableRDSWarningVue.$api.rds
        .queryDatabaseEngines("userName", getCookie(global.cookieName))
        .then((res) => {
          this.databaseEnginesList = res.data;
        });
    },
    // 查询监控指标
    searchMonitorIndex: function () {
      var searchMonitorIndexList = {
        accountId: this.relationalDatabaseServiceWarningForm.account,
      };
      // 如果不是Azure/腾讯云 monitor传1
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 0 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 1 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 4
      ) {
        searchMonitorIndexList.monitorModule = 1;
      }
      // 如果是Azure 且数据库引擎为MySQL  monitor传18
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines == "MySQL"
      ) {
        searchMonitorIndexList.monitorModule = 18;
      }
      // 如果是Azure 且数据库引擎为SQL Server  monitor传19
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines ==
          "SQL Server"
      ) {
        searchMonitorIndexList.monitorModule = 19;
      }
      // 腾讯云 传monitorModule=1 + databaseEngines区分MySQL/PostgreSQL
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
      ) {
        searchMonitorIndexList.monitorModule = 1;
        searchMonitorIndexList.databaseEngines = this.relationalDatabaseServiceWarningForm.databaseEngines;
      }

      tableRDSWarningVue.$api.alertRule
        .searchMonitorIndex(searchMonitorIndexList)
        .then((res) => {
          this.monitorIndexList = res.data;
        });
    },
    // 查询通知对象
    queryContacts: function () {
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 0 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 1 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 4 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
      ) {
        tableRDSWarningVue.$api.contact
          .queryContactsByAccountIdAndMonitorModule({
            monitorModule: 1,
            accountId: this.relationalDatabaseServiceWarningForm.account,
          })
          .then((res) => {
            this.notificationObjectList = res.data.contactList;
          });
      } else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines == "MySQL"
      ) {
        tableRDSWarningVue.$api.contact
          .queryContactsByAccountIdAndMonitorModule({
            monitorModule: 18,
            accountId: this.relationalDatabaseServiceWarningForm.account,
          })
          .then((res) => {
            this.notificationObjectList = res.data.contactList;
          });
      } else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines ==
          "SQL Server"
      ) {
        tableRDSWarningVue.$api.contact
          .queryContactsByAccountIdAndMonitorModule({
            monitorModule: 19,
            accountId: this.relationalDatabaseServiceWarningForm.account,
          })
          .then((res) => {
            this.notificationObjectList = res.data.contactList;
          });
      }
    },
    // 查询报警方式
    alarmWay: function () {
      tableRDSWarningVue.$api.alertRule
        .alarmWay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmWayList = res.data;
        });
    },
    // 查询报警延迟
    getAlarmDelay: function () {
      tableRDSWarningVue.$api.alertRule
        .alarmDelay("userName", getCookie(global.cookieName))
        .then((res) => {
          this.alarmDelayList = res.data;
        });
    },
    // 查询监控时间段
    searchMonitorPeriod: function () {
      this.$api.alertRule
        .monitorPeriod("userName", getCookie(global.cookieName))
        .then((res) => {
          this.monitorPeriodList = res.data;
        });
    },
    // 周期
    changeCycle: function () {
      // 查询阈值
      tableRDSWarningVue.selectMonitorIndexDefault();
    },
    // 连续周期
    changeContinousCycle: function () {
      // 查询阈值
      tableRDSWarningVue.selectMonitorIndexDefault();
    },
    // 统计数值
    changeStatisticsValue: function () {
      // 查询阈值
      tableRDSWarningVue.selectMonitorIndexDefault();
    },
    // 关系符号
    changeRelationshipSign: function () {
      // 查询阈值
      tableRDSWarningVue.selectMonitorIndexDefault();
      // 邮件模板
      tableRDSWarningVue.selectTemplate();
    },
    // 根据用户名查询Account列表
    getAccount: function () {
      // 清空表格
      this.tableRDSDate = [];
      // 查询云平台
      tableRDSWarningVue.getAccountType();
      // 查询方式
      tableRDSWarningVue.alarmWay();
      // 查询数据库引擎
      tableRDSWarningVue.queryDatabaseEngines();
      // 查询报警延时
      tableRDSWarningVue.getAlarmDelay();
      //监控时段
      tableRDSWarningVue.searchMonitorPeriod();
    },
    // 监控模块查询关联的机器人列表
    listEnterpriseWechatRobotsByMonitorModule: function () {
      var databaseList = {};
      // 如果不是Azure monitor传1
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 0 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 1 ||
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
      ) {
        databaseList.monitorModule = 1;
      }
      // 如果是Azure 且数据库引擎为MySQL  monitor传18
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines == "MySQL"
      ) {
        databaseList.monitorModule = 18;
      }
      // 如果是Azure 且数据库引擎为SQL Server  monitor传19
      else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.databaseEngines ==
          "SQL Server"
      ) {
        databaseList.monitorModule = 19;
      }

      tableRDSWarningVue.$api.enterpriseWechatRobot
        .listEnterpriseWechatRobotsByMonitorModule(databaseList)
        .then((res) => {
          this.enterpriseWechatRobotIdsList = res.data;
        });
    },
    //查询账号
    selectAccountByCloudPlatform: function () {
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey ==
        undefined
      ) {
        return;
      }
      this.$api.account
        .selectAccountByCloudPlatform(
          "type",
          this.relationalDatabaseServiceWarningForm.accountTypeSearchKey
        )
        .then((res) => {
          this.accountList = res.data;
        });
    },
    // 何时显示查询按钮
    searchChange: function () {
      if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2 &&
        this.relationalDatabaseServiceWarningForm.account &&
        this.relationalDatabaseServiceWarningForm.backupRegion &&
        this.relationalDatabaseServiceWarningForm.databaseEngines
      ) {
        this.isShowSearch = true;
      } else if (
        this.relationalDatabaseServiceWarningForm.accountTypeSearchKey != 2 &&
        this.relationalDatabaseServiceWarningForm.account &&
        this.relationalDatabaseServiceWarningForm.backupRegion
      ) {
        this.isShowSearch = true;
      } else {
        this.isShowSearch = false;
      }
    },
    //选择云平台
    searchAccountType: function () {
      this.searchChange();
      if (this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 2) {
        this.isDatabaseEngines = true;
        this.queryDatabaseEngines();
      } else if (this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6) {
        this.isDatabaseEngines = true;
        this.databaseEnginesList = [
          { id: 1, name: "MySQL" },
          { id: 2, name: "PostgreSQL" }
        ];
      } else {
        this.isDatabaseEngines = false;
      }
      this.relationalDatabaseServiceWarningForm.backupRegion = "";
      this.relationalDatabaseServiceWarningForm.databaseEngines = "";
      // 清空表格
      this.tableRDSDate = [];
      this.isNextClick = true;
      this.databaseList = [];
      tableRDSWarningVue.selectAccountByCloudPlatform();
    },
    // 选择账户
    changeAccount: function () {
      this.searchChange();
      if (
        this.relationalDatabaseServiceWarningForm.account == "" ||
        this.relationalDatabaseServiceWarningForm.account == null
      ) {
        return;
      }
      this.relationalDatabaseServiceWarningForm.backupRegion = "";
      this.relationalDatabaseServiceWarningForm.databaseEngines = "";
      // 清空表格
      this.tableRDSDate = [];
      this.isNextClick = true;
      this.databaseList = [];
      tableRDSWarningVue.$api.account
        .queryAccountRegions(
          "accountId",
          this.relationalDatabaseServiceWarningForm.account
        )
        .then((res) => {
          this.backupRegionList = res.data;
        });
      // 查询联系人组
      tableRDSWarningVue.listContactGroups();
      //查询联系人
      tableRDSWarningVue.queryContacts();
    },
    /***********存储区域**************************/
    selectBackupRegionAll() {
      this.relationalDatabaseServiceWarningForm.backupRegion = [];
      if (this.singleBackupRegion) {
        this.backupRegionList.map((item) => {
          this.relationalDatabaseServiceWarningForm.backupRegion.push(
            item.name
          );
        });
      } else {
        this.relationalDatabaseServiceWarningForm.backupRegion = [];
      }
    },
    // 切换存储区域
    changebackupRegion: function (val) {
      if (val.length === this.backupRegionList.length && val.length != 0) {
        this.singleBackupRegion = true;
      } else {
        this.singleBackupRegion = false;
      }
      this.searchChange();
      this.relationalDatabaseServiceWarningForm.databaseEngines = "";
      this.tableRDSDate = [];
      this.databaseList = [];
      this.isNextClick = true;
    },
    // 数据库引擎
    changeDatabaseEngines: function () {
      this.searchChange();
      this.tableRDSDate = [];
      this.databaseList = [];
      this.isNextClick = true;
    },
    // 全选 单选
    /***********************************************************************************/
    // 单选
    selectChange(selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableRDSDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        // 状态
        var TableRDSCopy = new Object();
        TableRDSCopy.databaseId = this.selection[i].databaseId;
        TableRDSCopy.name = this.selection[i].name;
        TableRDSCopy.engine = this.selection[i].engine;
        TableRDSCopy.state = this.selection[i].state;
        TableRDSCopy.region = this.selection[i].region;
        TableRDSCopy.type = this.selection[i].type;
        TableRDSCopy.awsZone = this.selection[i].awsZone;
        TableRDSCopy.accountId = this.selection[i].accountId;
        TableRDSCopy.allocatedStorage = this.selection[i].allocatedStorage;
        TableRDSCopy.iops = this.selection[i].iops;
        this.newTableRDSDateList.push(TableRDSCopy);
      }
      // 选了数据 可以点击下一步
      if (this.newTableRDSDateList.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 全选
    selectAll: function (selection) {
      // 所有数据
      this.selection = selection;
      // 清空数组
      this.newTableRDSDateList = [];
      for (var i = 0; i < this.selection.length; i++) {
        var TableRDSCopy = new Object();
        TableRDSCopy.databaseId = this.selection[i].databaseId;
        TableRDSCopy.name = this.selection[i].name;
        TableRDSCopy.engine = this.selection[i].engine;
        TableRDSCopy.state = this.selection[i].state;
        TableRDSCopy.region = this.selection[i].region;
        TableRDSCopy.type = this.selection[i].type;
        TableRDSCopy.awsZone = this.selection[i].awsZone;
        TableRDSCopy.accountId = this.selection[i].accountId;
        TableRDSCopy.allocatedStorage = this.selection[i].allocatedStorage;
        TableRDSCopy.iops = this.selection[i].iops;
        this.newTableRDSDateList.push(TableRDSCopy);
      }
      if (this.selection.length == 0) {
        this.isNextClick = true;
      } else {
        this.isNextClick = false;
      }
    },
    // 创建添加或编辑报警
    /**********************************************************************************/
    ok: function (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          var alertList = {
            monitorModule: 1,
            alertRuleName: this.relationalDatabaseServiceWarningForm.ruleName,
            monitorIndex:
              this.relationalDatabaseServiceWarningForm.monitorIndex,
            cycle: this.relationalDatabaseServiceWarningForm.cycle,
            continousCycle:
              this.relationalDatabaseServiceWarningForm.continousCycle,
            statisticsValue:
              this.relationalDatabaseServiceWarningForm.statisticsValue,
            relationshipSign:
              this.relationalDatabaseServiceWarningForm.relationshipSign,
            thresholdValue:
              this.relationalDatabaseServiceWarningForm.thresholdValue,
            accountId: this.relationalDatabaseServiceWarningForm.account,
            noticeType: this.relationalDatabaseServiceWarningForm.noticeType,
            unit: this.units,
            delay: this.relationalDatabaseServiceWarningForm.alarmDelay,
            monitorPeriod:
              this.relationalDatabaseServiceWarningForm.monitorPeriod,
            contactType: this.relationalDatabaseServiceWarningForm.contactType,
            enterpriseWechatRobotIds:
              this.relationalDatabaseServiceWarningForm
                .enterpriseWechatRobotIds,
            aiInterventionEnabled:
              this.relationalDatabaseServiceWarningForm.aiInterventionEnabled,
          };

          if (
            this.relationalDatabaseServiceWarningForm.accountTypeSearchKey ==
              0 ||
            this.relationalDatabaseServiceWarningForm.accountTypeSearchKey ==
              1 ||
            this.relationalDatabaseServiceWarningForm.accountTypeSearchKey == 6
          ) {
            alertList.monitorModule = 1;
          } else if (
            this.relationalDatabaseServiceWarningForm.accountTypeSearchKey ==
              2 &&
            this.relationalDatabaseServiceWarningForm.databaseEngines == "MySQL"
          ) {
            alertList.monitorModule = 18;
          } else if (
            this.relationalDatabaseServiceWarningForm.accountTypeSearchKey ==
              2 &&
            this.relationalDatabaseServiceWarningForm.databaseEngines ==
              "SQL Server"
          ) {
            alertList.monitorModule = 19;
          }

          // 如果联系方式是联系人 传通知对象
          if (this.relationalDatabaseServiceWarningForm.contactType == 0) {
            alertList.contactIDs =
              this.relationalDatabaseServiceWarningForm.notificationObject;
          }
          // 如果联系方式是联系人组 传联系人组
          else if (this.relationalDatabaseServiceWarningForm.contactType == 1) {
            alertList.contactGroupIds =
              this.relationalDatabaseServiceWarningForm.contactGroupIds;
          }

          if (this.relationalDatabaseServiceWarningForm.id > 0) {
            alertList.id = this.relationalDatabaseServiceWarningForm.id;
            alertList.databaseDTOList = this.newTableRDSDateList;
            // 编辑告警
            this.addloading = true;
            tableRDSWarningVue.$api.alertRule
              .updateAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  this.relationalDatabaseServiceWarningForm.notificationObject =
                    [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t("common.editSuccess"));
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowSearch = false;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          } else {
            // 添加告警
            this.addloading = true;
            alertList.databaseDTOList = this.newTableRDSDateList;
            tableRDSWarningVue.$api.alertRule
              .createAlertRule(alertList)
              .then((res) => {
                this.data = res.data;
                setTimeout(() => {
                  this.reload();
                  tableRelationalDatabaseService.methods.showAll();
                  this.relationalDatabaseServiceWarningForm.notificationObject =
                    [];
                  this.$refs[name].resetFields();
                  this.loading = false;
                  this.$emit("on-ok", this.form);
                  this.$nextTick(() => {
                    this.loading = true;
                  });
                  this.$Message.success(this.$t("common.addSuccess"));
                  // 禁止点击下一步
                  this.isNextClick = true;
                  this.isShowEmail = false;
                  this.isShowWeChat = false;
                  this.addloading = false;
                  this.modal = false;
                  this.wechatWarningVisible = false;
                  this.isAddOrEdit = true;
                }, 1000);
              });
          }
        } else {
          //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
          this.loading = false;
          setTimeout(() => {
            this.loading = true;
          }, 0);
          if (this.relationalDatabaseServiceWarningForm.id > 0) {
            this.$Message.error(this.$t("common.editFail"));
          } else {
            this.$Message.error(this.$t("common.addFail"));
          }
        }
      });
    },
    // 取消
    cancel: function (name) {
      this.wechatWarningVisible = false;
      this.isAddOrEdit = true;
      this.isShowSearch = false;
      this.isShowEmail = false;
      this.isShowWeChat = false;
      this.isNextClick = true;
      this.modal = false;
      this.$emit("on-cancel");
      this.relationalDatabaseServiceWarningForm.notificationObject = [];
      this.$nextTick(() => {
        this.$refs[name].resetFields();
      });
      // 清空表格
      this.tableRDSDate = [];
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/monitor/rds/AddOrUpdateRelationalDatabaseServiceWarning.vue